import { useLocaleState, useRecordContext } from "react-admin";

import LabelAttachedField from "../../unit/LabelAttachedField";
import LabelField from "../../unit/LabelField";
import { Grid } from "@mui/material";

const FinalReview = ({ ...props }) => {
  const { appId } = props;
  const record = useRecordContext();
  const [locale] = useLocaleState();
  if (!record) return null;

  const movestatus = "move " + record.fromstatus + " to " + record.tostatus;
  let reviewresult = "";
  if (record.reviewResult == "Agree") {
    reviewresult = "Proceed";
  } else if (record.reviewResult == "Override") {
    reviewresult = "Override";
  } else if (record.reviewResult == "Reject") {
    reviewresult = "Reject";
  } else {
    reviewresult = record.sOption;
  }

  if (record.sComment != "No Final Review") {
    return (
      <>
        <Grid container spacing={1} sx={{ mb: 1 }}>
          <Grid item xs={12} md={6} lg={6}>
            <LabelField
              title="Date Reviewed"
              value={record.created_at}
              format="date"
              prefix="EST"
            />
            <LabelField title="Reviewed By" value={record.sOper} />
            <LabelField title="Review Result" value={reviewresult} />
            <LabelField title="Review Decision" value={record.sDecision} />
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
            {record.sComment && record.sComment.length > 0 ? (
              <LabelField
                title="Comment"
                value={record.sComment}
                format="richtext"
                titlePosition="top"
              />
            ) : (
              <></>
            )}
            {record.filelist && record.filelist.length > 0 ? (
              <LabelAttachedField list={record.filelist} titlePosition="top" />
            ) : (
              <></>
            )}
          </Grid>
        </Grid>
      </>
    );
  } else {
    return <>N/A</>;
  }
};

export default FinalReview;
